import _defineProperty from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import _toConsumableArray from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import "core-js/modules/es6.weak-map.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.regexp.constructor.js";
import "core-js/modules/es6.regexp.flags.js";
import "core-js/modules/es6.set.js";
import "core-js/modules/es6.map.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.keys.js";
// adapted from https://stackoverflow.com/a/40294058

export default function cloneDeep(data) {
  var hash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new WeakMap();
  if (Object(data) !== data) return data;
  if (hash.has(data)) return hash.get(data);
  var result = data instanceof Date ? new Date(data) : data instanceof RegExp ? new RegExp(data.source, data.flags) : data instanceof Set ? new Set() : data instanceof Map ? new Map() : typeof data.constructor !== 'function' ? Object.create(null) : data.prototype !== void 0 && typeof data.prototype.constructor === 'function' ? data : new data.constructor();
  if (typeof data.constructor === 'function' && typeof data.valueOf === 'function') {
    var val = data.valueOf();
    if (Object(val) !== val) {
      var _result = new data.constructor(val);
      hash.set(data, _result);
      return _result;
    }
  }
  hash.set(data, result);
  if (data instanceof Set) {
    data.forEach(function (val) {
      result.add(cloneDeep(val, hash));
    });
  } else if (data instanceof Map) {
    data.forEach(function (val, key) {
      result.set(key, cloneDeep(val, hash));
    });
  }
  return Object.assign.apply(Object, [result].concat(_toConsumableArray(Object.keys(data).map(function (key) {
    return _defineProperty({}, key, cloneDeep(data[key], hash));
  }))));
}